var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyWaterTokens(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.963,
    height: 62.702,
    viewBox: "0 0 53.963 62.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.359,9,15.012,23.092a20.509,20.509,0,0,0,0,27.886,18.193,18.193,0,0,0,26.711,0,20.525,20.525,0,0,0,0-27.9ZM39.325,48.695a14.886,14.886,0,0,1-21.915,0,17.184,17.184,0,0,1,0-23.354L28.359,13.763,39.325,25.341h0a17.184,17.184,0,0,1,0,23.436Z",
    transform: "translate(6.238 5.886)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.183,18.193a6.947,6.947,0,0,0,4.962-2.2,7.79,7.79,0,0,0,0-10.6L31.183,0,26.138,5.309a7.823,7.823,0,0,0,0,10.6,6.947,6.947,0,0,0,5.045,2.282Z",
    transform: "translate(15.737)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.646,10.56,10.3,2.82,2.976,10.56a11.2,11.2,0,0,0,0,15.2,10.023,10.023,0,0,0,14.67,0,11.2,11.2,0,0,0,0-15.2ZM15.232,23.478a6.616,6.616,0,0,1-9.924,0,7.84,7.84,0,0,1,0-10.651L10.27,7.633l4.962,5.193h0a7.79,7.79,0,0,1,0,10.651Z",
    transform: "translate(-0.002 1.844)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.714,26.805H25.546V22.654a1.654,1.654,0,1,0-3.308,0v4.184H18.054a1.654,1.654,0,1,0,0,3.308h4.184v4.085a1.654,1.654,0,1,0,3.308,0V30.113h4.168a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(10.722 13.733)",
    fill: "#efc700"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyWaterTokens);
export default __webpack_public_path__ + "static/media/buy_water_tokens.80f0df8907af6ed723b02dce35eb264e.svg";
export { ForwardRef as ReactComponent };